
// TODO: when clicking on an unread message thread show a popuop for 2 seconds that says "taking you to this schedule"

import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { 
  SET_UNREAD_MESSAGES_DIALOGUE_OPEN, SET_SCHEDULE_MESSAGES_DIALOGUE_ID, SET_PATH, GET_SCHEDULE_MESSAGE_THREADS, REJECT_SUBSCRIPTION_INVITE, ACCEPT_SUBSCRIPTION_INVITE,
    SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING,
} from '../actions/types';
import { siteboardAction } from '../actions/defaultActions';
import { millisDurationToString, keyCountInObject, objectValuesToList } from '../Util';
import PopupWindow from './PopupWindow';
import AlertCountBubble from './AlertCountBubble';

import InboxIcon from '../icons/inboxIcon';
import MailOpenIcon from '../icons/mailOpenIcon';

// test cases
const testScrollPanes = false; // add a bunch of copies to scrollable area to see what they look like when full of data

const UnreadMessageDialogue = ({ _users, _projects, _unreadScheduleMessageThreads, _subscriptionInvites, siteboardAction }) => {
  const [currentTimestampReference, setCurrentTimestampReference] = useState(null); // used to periodically trigger an update of the displayed elapsed time of messages

  let totalUnreadMessages = 0;
  for(const threadId in _unreadScheduleMessageThreads) {
    if(!(_unreadScheduleMessageThreads[threadId].projectId in _projects)) continue;
    totalUnreadMessages += _unreadScheduleMessageThreads[threadId].unreadCount;
  }
  totalUnreadMessages += keyCountInObject(_subscriptionInvites);

  const closeDialogue = () => {
    siteboardAction(SET_UNREAD_MESSAGES_DIALOGUE_OPEN, { isOpen: false });
  };

  // Refresh message elapsed timestamps periodically by updating the current reference timestamp
  useEffect(() => {
    const updateInterval = setInterval(() => {
      setCurrentTimestampReference(new Date().getTime());
    }, 20000);
    return () => { // remove listener when component unloads
      clearInterval(updateInterval);
    };
  }, []);

  const getUserAvatar = (user, forScheduleMessageThread) => {
    let userIsInThread = false;
    //if(forScheduleMessageThread) {
    //  const threadMember = forScheduleMessageThread.members[user.id];
    //  userIsInThread = threadMember.enteredThreadTimestamp > user.lastOnlineTimestamp && threadMember.enteredThreadTimestamp > threadMember.leftThreadTimestamp;
    //}
    
    let userStatus = 'offline';
    if(userIsInThread) {
      userStatus = 'chatting';
    } else if(user.isOnline) {
      userStatus = 'online';
    }

    return (
      <div className='relative flex justify-center items-center uppercase bg-[#f99917] rounded-full p-1 w-9 h-9 min-h-9 min-w-9 text-center text-black font-semibold'>
        <div>{user.firstName[0]}{user.lastName[0]}</div>
        <div className={`absolute bottom-0 translate-y-[70%] ${userStatus === 'offline' ? 'text-red-400' : 'text-green-400'} text-[0.6em] py-[2px] px-1 bg-[#444] rounded`}>
          {userStatus}
        </div>
      </div>
    );
  };

  const getShorthandElapsedSinceTimestamp = (timestamp) => {
    let timeSinceLatestMessage = '';
    const millisecondsElapsed = new Date().getTime() - timestamp;
    const secondsElapsed = millisecondsElapsed / 1000;
    const minutesElapsed = secondsElapsed / 60;
    const hoursElapsed = secondsElapsed / 3600;
    const daysElapsed = secondsElapsed / 86400;

    if(daysElapsed >= 1) {
      timeSinceLatestMessage = Math.round(daysElapsed) + "d";
    } else if(hoursElapsed >= 1) {
      timeSinceLatestMessage = Math.round(hoursElapsed) + "h";
    } else if(minutesElapsed >= 1) {
      timeSinceLatestMessage = Math.round(minutesElapsed) + "m";
    } else {
      timeSinceLatestMessage = parseInt(secondsElapsed) + "s";
    }

    return timeSinceLatestMessage;
  };

  const listUnreadThreadsJSX = () => {
    // Create a list of unread message thread and sort them with latest message thread at the top
    const unreadScheduleMessageThreadsList = [];
    for(const unreadScheduleMessageThreadId in _unreadScheduleMessageThreads) {
      const unreadThread = _unreadScheduleMessageThreads[unreadScheduleMessageThreadId];
      if(!(unreadThread.projectId in _projects)) continue;
      if(!(unreadThread.latestMessageSenderId in _users)) continue;

      for(let i = 0; i < (testScrollPanes ? 20 : 1); i++) {
        unreadScheduleMessageThreadsList.push(unreadThread);
      }
    }
    unreadScheduleMessageThreadsList.sort((one, two) => two.latestUnreadTimestamp - one.latestUnreadTimestamp);

    if (unreadScheduleMessageThreadsList.length === 0) return <></>;

    // If we have existing conversations
    if (unreadScheduleMessageThreadsList.length > 0) {
      return (
        <div className='grow flex flex-col gap-2 mt-2'>
          <div className='grow flex flex-col gap-y-1 basis-0 overflow-y-auto'>
            {unreadScheduleMessageThreadsList.map((unreadThread, index) => (
              <button 
                key={index} 
                className='flex flex-col gap-y-1 hover:bg-[#555] px-1 sm:px-2 py-3 rounded-lg'
                onClick={() => {
                  closeDialogue();

                  // Fetch schedule message threads for the schedule
                  siteboardAction(GET_SCHEDULE_MESSAGE_THREADS, { projectId: unreadThread.projectId, });

                  setTimeout(() => {
                    siteboardAction(SET_PATH, { path: 'projectId#' + unreadThread.projectId + '#schedule' });
                    setTimeout(() => {
                      siteboardAction(SET_SCHEDULE_MESSAGES_DIALOGUE_ID, { projectId: unreadThread.projectId, scheduleMessageThreadId: unreadThread.scheduleMessageThreadId });
                    }, 750);
                  }, 300);
                }}
              >
                <div className='text-left w-full'>
                  <p className='inline-block'>{_projects[unreadThread.projectId].name}, </p>
                  <p className='inline-block ml-1'>3-Week</p>
                  <p className='hidden sm:inline-block ml-1'>Schedule</p>
                </div>
                <div className='flex justify-center items-start gap-x-2 w-full'>
                  {/* avatar for last message sender */}
                  {getUserAvatar(_users[unreadThread.latestMessageSenderId], unreadThread.scheduleMessageThreadId)}
                  {/* project name, schedule date, and last message */}
                  <div className='grow flex flex-col justify-center items-start gap-y-1 overflow-hidden'>
                    <div className='flex w-full overflow-hidden'>
                      <div className='relative flex gap-x-1 text-left whitespace-nowrap leading-[1.2em]'>
                        <div>{_users[unreadThread.latestMessageSenderId].firstName}</div>
                        <div>{_users[unreadThread.latestMessageSenderId].lastName}</div>
                        <div className='absolute top-0 left-full translate-x-[4px] opacity-50'>({_users[unreadThread.latestMessageSenderId].email})</div>
                      </div>
                    </div>
                    <div className='font-bold max-h-[2.4em] leading-[1.2em] text-left'>{unreadThread.latestMessageContent}</div>
                  </div>
                  {/* last message time and unread message count */}
                  <div className='flex flex-col self-start text-sm gap-y-1'>
                    <div>{getShorthandElapsedSinceTimestamp(unreadThread.latestUnreadTimestamp)}</div>
                    <AlertCountBubble totalUnreadMessages={unreadThread.unreadCount} />
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      );
    }
  };

  const listSubscriptionInvitesJSX = () => {
    return (
      <div>
        {objectValuesToList(_subscriptionInvites).map((invite, index) => (
          <div key={index} className='flex flex-col gap-4 bg-[#222] p-3 rounded-lg'>
            <div className='flex justify-between items-start'>
              <h2 className='flex items-center gap-1.5 text-[1.4em] font-medium'>Account Invite</h2>
              <div className='hidden sm:block text-sm'>{millisDurationToString(new Date().getTime()-invite.createdTimestamp)} ago</div>
              <div className='sm:hidden text-sm'>{getShorthandElapsedSinceTimestamp(invite.createdTimestamp)}</div>
            </div>
            <div>"{invite.inviterName}" <div className='inline text-[#bbb]'>({invite.inviterEmail})</div> has invited you to join their account{invite.subscriptionRole === 'Admin' ? ' as an Account Manager' : ''}{keyCountInObject(invite.projectMemberships) > 0 ? ', and has assigned you to ' + keyCountInObject(invite.projectMemberships) + ' project' +(keyCountInObject(invite.projectMemberships) === 1 ? '' : 's') : ''}.</div>
            <div className='flex gap-2'>
              <button  
                className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
                onClick={() => {
                  siteboardAction(REJECT_SUBSCRIPTION_INVITE, { subscriptionInvite: invite });
                }}
              >
                Reject Invite
              </button>
              <button  
                className={`bg-[#471cff] hover:bg-[#603aff] text-white w-full py-[7px] font-bold select-none rounded-lg`}
                onClick={() => {
                  const onSuccess = (validOutput) => {
                    siteboardAction(SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, {subscriptionId: validOutput.subscription.id})
                  };
                  siteboardAction(ACCEPT_SUBSCRIPTION_INVITE, { subscriptionInvite: invite }, onSuccess);
                }}
              >
                Accept Invite
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <PopupWindow title={`Notifications`} closeDialogue={closeDialogue} bgStyle='bg-[#333]' isFullHeight={true}>
      <div className='grow flex flex-col max-w-screen-lg bg-[#333] text-white'>
        <div className='h-0 w-[90vw] max-w-full'></div>
        {totalUnreadMessages > 0 &&
          <>
            <div className='mb-2'>You have {totalUnreadMessages} notification{totalUnreadMessages === 1 ? '' : 's'}:</div>
            {listSubscriptionInvitesJSX()}
            {listUnreadThreadsJSX()}
          </>
        }
        {totalUnreadMessages === 0 &&
          <div className='grow flex flex-col justify-center items-center'>
            <div className='flex justify-center items-center gap-x-3 text-2xl px-4 text-center'><InboxIcon size='1.2em' />No notifications</div>
          </div>  
        }
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _users: state.serverSynced.users,
  _projects: state.serverSynced.projects,
  _unreadScheduleMessageThreads: state.serverSynced.unreadScheduleMessageThreads,
  _subscriptionInvites: state.serverSynced.subscriptionInvites,
}};
export default connect(mapStateToProps, { siteboardAction })(UnreadMessageDialogue);
